<template>
    <div class="agent-page">
        <div style="display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title" >{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">专家抽取</h2>
            </div>
            <div style="display: flex; align-items: center; gap: 10px;">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack"
                    >返回项目流程界面</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="handleAddExpert" >新增专家抽取</el-button>
            </div>
        </div>
        <!-- 内容区域 -->
        <div class="content-wrap">
            <!-- 专家抽取表格 -->
            <el-table :data="expertList" style="width: 100%" v-loading="loading">
               <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="selectCount" label="抽取专家数量"  align="center"></el-table-column>
                <el-table-column prop="contactName" label="联系人" align="center"></el-table-column>
                <el-table-column prop="contactMobile" label="联系电话"  align="center"></el-table-column>
                <el-table-column prop="address" label="评标地点"  align="center"></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                        <!-- <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination-wrap">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { listPage } from '@/api/expertselection/api'
export default {
    data() {
        return {
            projectTitle: '',
            projectCode: this.$route.query.projectCode,
            committeeId: this.$route.query.id,
            loading: false,
            expertList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
        }
    },
    mounted() {
        this.loadExpertList()
        this.getProjectInfo()
    },
    methods: {
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        //  获取标题
        async getProjectInfo() {
            this.projectTitle = await loadProjectDetail(this.projectCode);
        },
        async loadExpertList() {
            this.loading = true
            try {
                const res = await listPage({
                    projectCode: this.projectCode,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                })

                if (res.code == 200) {
                    const page = res.data || {}
                    this.expertList = page.records || []
                    this.total = Number(page.total) || 0
                    this.pageSize = Number(page.size) || this.pageSize
                    this.currentPage = Number(page.current) || this.currentPage
                } else {
                    this.$message.error(res.msg)
                }
            } catch (e) {
                console.error(e)
                this.$message.error('网络异常')
            } finally {
                this.loading = false
            }
        },
        // 新增专家抽取
        handleAddExpert() {
            this.$router.push({ name: 'expertExtractionFrom',query:{
                projectCode:this.projectCode,
                committeeId:this.committeeId
            } })
        },
        // 编辑专家抽取
        handleEdit(row) {
            this.$router.push({
                name: 'expertExtractionFrom',
                query: { id: row.id, mode: 'edit', projectCode: this.projectCode, committeeId: this.committeeId }
            })
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.loadExpertList()
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val
            this.loadExpertList()
        },

    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

/* 内容区域样式 */
.content-wrap {
    width: 100%;
    border-radius: 8px;
    margin-top: 20px;
}

/* 分页样式 */
.pagination-wrap {
    margin-top: 20px;
    text-align: right;
}

/* 表格样式 */
.el-table {
    .el-button {
        margin: 0 5px;
    }
}

/* 对话框样式 */
.dialog-footer {
    text-align: right;
}

/* 表单样式 */
.expert-form {
    .el-form-item {
        margin-bottom: 20px;
    }

    .el-form-item__label {
        font-weight: 500;
        color: #333;
    }

    .el-input {
        .el-input__inner {
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        }

        .el-input__inner:focus {
            border-color: #409eff;
        }
    }

    .el-select {
        .el-input__inner {
            border-radius: 4px;
        }
    }

    .el-radio-group {
        .el-radio {
            margin-right: 20px;
            margin-bottom: 10px;
        }

        .el-radio__label {
            font-size: 14px;
            color: #333;
        }
    }
}

/* 表格部分样式 */
.table-section {
    margin-top: 30px;

    h4 {
        margin: 0 0 15px 0;
        font-size: 16px;
        font-weight: 500;
        color: #333;
        padding-left: 10px;
    }

    .el-table {
        margin-bottom: 20px;

        .el-table__header {
            background-color: #f5f7fa;
        }

        .el-input {
            .el-input__inner {
                border: none;
                background: transparent;
                padding: 0;
            }
        }
    }

    .table-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        h4 {
            margin: 0;
            font-size: 16px;
            font-weight: 500;
            color: #303133;
        }

        .el-button {
            margin-left: 10px;
        }
    }

    .action-buttons {
        display: flex;
        gap: 8px;
        align-items: center;

        .el-button {
            flex-shrink: 0;
        }
    }

    .table-actions {
        margin-top: 15px;
        text-align: left;

        .el-button {
            margin-right: 10px;
        }
    }
}

/* 对话框样式 */
.el-dialog {
    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #ebeef5;
    }

    .el-dialog__body {
        padding: 20px;
        max-height: 70vh;
        overflow-y: auto;
    }

    .el-dialog__footer {
        padding: 10px 20px 20px;
        border-top: 1px solid #ebeef5;
    }
}

/* 抽取地区样式 - 现代化左右布局 */
.region-container {
    display: flex;
    gap: 24px;
    align-items: flex-start;

    .region-left {
        flex: 1;
        background: #fafbfc;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        padding: 20px;

        .region-selector {
            margin-bottom: 20px;

            .selector-row {
                display: flex;
                align-items: center;
                margin-bottom: 12px;

                &:last-child {
                    margin-bottom: 0;
                }

                .selector-label {
                    font-size: 14px;
                    color: #606266;
                    font-weight: 500;
                    min-width: 60px;
                    margin-right: 12px;
                }
            }
        }

        .region-selection-area {
            border: 1px solid #e4e7ed;
            border-radius: 6px;
            margin-bottom: 20px;
            background: #fff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

            .selection-header {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: #fff;
                padding: 12px 16px;
                font-size: 14px;
                font-weight: 500;
                border-radius: 6px 6px 0 0;
                display: flex;
                align-items: center;

                i {
                    margin-right: 8px;
                    font-size: 16px;
                }
            }

            .selection-content {
                padding: 16px;
                min-height: 120px;

                .district-checkboxes {
                    .checkbox-row {
                        display: flex;
                        flex-wrap: wrap;
                        margin-bottom: 8px;

                        .district-checkbox {
                            flex: 0 0 33.333%;
                            margin-bottom: 8px;
                            padding-right: 8px;

                            .el-checkbox__label {
                                font-size: 13px;
                                color: #606266;
                            }
                        }
                    }
                }

                .empty-hint {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 80px;
                    color: #909399;
                    font-size: 14px;

                    i {
                        margin-right: 8px;
                        font-size: 16px;
                    }
                }
            }
        }

        .region-actions {
            text-align: center;

            .add-btn {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                border: none;
                border-radius: 6px;
                padding: 10px 24px;
                font-size: 14px;
                font-weight: 500;
                box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
                transition: all 0.3s ease;

                &:hover:not(:disabled) {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
                }

                &:disabled {
                    background: #c0c4cc;
                    box-shadow: none;
                    cursor: not-allowed;
                }
            }
        }
    }

    .region-right {
        flex: 1;

        .selected-regions {
            border: 1px solid #e4e7ed;
            border-radius: 8px;
            background: #fff;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            height: 100%;

            .selected-header {
                color: #fff;
                padding: 12px 16px;
                border-radius: 8px 8px 0 0;
                display: flex;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                justify-content: space-between;
                align-items: center;

                .header-left {
                    display: flex;
                    align-items: center;

                    i {
                        margin-right: 8px;
                        font-size: 16px;
                    }

                    span {
                        font-size: 14px;
                        font-weight: 500;
                        margin-right: 8px;
                    }

                    .count-badge {
                        .el-badge__content {
                            background: rgba(255, 255, 255, 0.2);
                            border: 1px solid rgba(255, 255, 255, 0.3);
                            color: #fff;
                        }
                    }
                }

                .clear-btn {
                    color: #fff;
                    font-size: 12px;
                    padding: 4px 8px;
                    border-radius: 4px;
                    background: rgba(255, 255, 255, 0.1);
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    transition: all 0.3s ease;

                    &:hover:not(:disabled) {
                        background: rgba(255, 255, 255, 0.2);
                        transform: translateY(-1px);
                    }

                    &:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }
            }

            .selected-content {
                padding: 20px;
                min-height: 200px;

                .empty-selection {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 160px;
                    color: #909399;
                    text-align: center;

                    i {
                        font-size: 48px;
                        margin-bottom: 12px;
                        opacity: 0.5;
                    }

                    p {
                        font-size: 16px;
                        margin: 0 0 8px 0;
                        font-weight: 500;
                    }

                    span {
                        font-size: 14px;
                        opacity: 0.8;
                    }
                }

                .selected-tags {
                    .region-tag {
                        margin: 6px 8px 6px 0;
                        border-radius: 16px;
                        padding: 0px 12px;
                        font-size: 13px;
                        background: #f0f9ff;
                        border: 1px solid #b3d8ff;
                        color: #409eff;
                        transition: all 0.3s ease;

                        &:hover {
                            background: #e1f3ff;
                            transform: translateY(-1px);
                            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
                        }

                        .el-tag__close {
                            color: #409eff;

                            &:hover {
                                background: #409eff;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
    }
}

// 抽取专业表格样式
.expert-extraction-section {
    margin-top: 20px;

    .section-title {
        font-size: 14px;
        color: #333;
        font-weight: 500;
        min-width: 80px;
        padding-top: 8px;
    }
}

/* 网格布局样式 */
.expert-dialog {
    .el-dialog__body {
        padding: 20px;
    }
}

.dialog-content {
    max-height: 70vh;
    overflow-y: auto;
}

.expert-form-grid {
    .form-section {
        margin-bottom: 24px;
        border: 1px solid #e8e8e8;
        border-radius: 8px;
        background: #fafafa;
        overflow: hidden;

        .section-title {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 12px 20px;
            font-size: 16px;
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 8px;
            margin: 0;

            i {
                font-size: 18px;
            }
        }

        .section-content {
            padding: 20px;
            background: white;

            .el-form-item {
                margin-bottom: 18px;

                .el-form-item__label {
                    font-weight: 500;
                    color: #333;
                }

                .el-input,
                .el-select,
                .el-date-picker {
                    .el-input__inner {
                        border-radius: 6px;
                        border: 1px solid #dcdfe6;
                        transition: all 0.3s;

                        &:focus {
                            border-color: #667eea;
                            box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
                        }
                    }
                }

                .el-radio-group {
                    .el-radio {
                        margin-right: 20px;
                    }
                }
            }
        }
    }

    .el-table {
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .el-table__header {
            background: #f8f9fa;
        }

        .el-table__body {
            tr:hover {
                background-color: #f5f7fa;
            }
        }
    }

    .dialog-footer {
        text-align: center;
        padding: 20px;
        background: #f8f9fa;
        border-top: 1px solid #e8e8e8;

        .el-button {
            min-width: 100px;
            border-radius: 6px;
            font-weight: 500;
        }
    }
}
</style>